import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import arrow1 from "../../assets/images/icon/arrow-1.svg";
import FunnelSeries from "./FunnelSeries";
import { getJobRoundDetails } from "helpers/backend_helper";
import { toast } from "react-toastify";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";
import { getSubdomain } from "helpers/utils";

const FunnelChart = props => {
  const { t } = useTranslation();
  const [jobDetails, setJobDetails] = useState({});
  const [assessmentRounds, setAssessmentRounds] = useState([]);
  const [selectedJobTitle, setSelectedJobTitle] = useState("");
  const [totalApplicantsForJob, setTotalApplicantsForJob] = useState(0);

  const type = props?.type || "";
  const startDate = props?.startDate || "";
  const endDate = props?.endDate || "";
  const jobTitles = props?.jobTitles || [];
  const [data, setData] = useState({});
  let datafromDashboard = props?.data || {};

  useEffect(() => {
    setData(datafromDashboard);
  }, [props]);

  useEffect(() => {
    if (selectedJobTitle) {
      fetchJobDetails(selectedJobTitle);
    }
  }, [selectedJobTitle, props]);

  const handleJobTitleChange = e => {
    const jobId = e.target.value;
    setSelectedJobTitle(jobId);
  };

  const fetchJobDetails = async jobId => {
    try {
      const response = await getJobRoundDetails(
        jobId,
        type,
        startDate,
        endDate
      );
      let responseData = decryptDataFromArray(response);

      if (responseData?.data) {
        let tempCount = 0;
        tempCount += responseData?.data?.onboardedApplicants?.length || 0;
        tempCount += responseData?.data?.onholdApplicants?.length || 0;
        tempCount += responseData?.data?.rejectedApplicants?.length || 0;
        tempCount += responseData?.data?.selectedApplicants?.length || 0;
        tempCount += responseData?.data?.pendingApplicants?.length || 0;
        tempCount +=
          responseData?.data?.screeningScheuledApplicants?.length || 0;

        responseData?.data?.assessmentRounds?.forEach(round => {
          tempCount += round.applicantList?.length || 0;
        });

        setTotalApplicantsForJob(tempCount);
        setJobDetails(responseData?.data);
        setAssessmentRounds(responseData?.data?.assessmentRounds || []);
      } else {
        setJobDetails({});
        setAssessmentRounds([]);
      }
    } catch (err) {
      toast.error(t(`Dashboard.Error job details`));
    }
  };

  const scheduleColumn = {
    stage: t(`Dashboard.Schedule Interview`),
    applicants: data?.scheduledUsers || 0,
    percentage: Math.round(
      ((data?.scheduledUsers || 0) / (data?.totalApplicants || 1)) * 100
    ),
  };
  const myData = [
    {
      stage: t(`Dashboard.Total Applications`),
      applicants: data?.totalApplicants || 0,
      percentage: 100,
    },
    {
      stage: t(`Dashboard.Assessment Sent`),
      applicants: data?.screeningUsers || 0,
      percentage: Math.round(
        ((data?.screeningUsers || 0) / (data?.totalApplicants || 1)) * 100
      ),
    },
    ...(getSubdomain() !== "mahindra" ? [scheduleColumn] : []),

    {
      stage: t(`Dashboard.Selected`),
      applicants: data?.selectedUsers || 0,
      percentage: Math.round(
        ((data?.selectedUsers || 0) / (data?.totalApplicants || 1)) * 100
      ),
    },
    {
      stage: t(`Dashboard.Onboarded`),
      applicants: data?.onboardedUsers || 0,
      percentage: Math.round(
        ((data?.onboardedUsers || 0) / (data?.totalApplicants || 1)) * 100
      ),
    },
  ];

  let dynamicStages =
    assessmentRounds.map(round => ({
      stage: round.interview_title,
      applicants: round.applicantList.length,
      percentage: Math.round(
        ((round.applicantList.length || 0) / (totalApplicantsForJob || 1)) * 100
      ),
    })) || [];

  let jobSpecificData = [
    {
      stage: t(`Dashboard.Total Job Applications`),
      applicants: totalApplicantsForJob || 0,
      percentage: 100,
    },
    // {
    //   stage: "New Applications",
    //   applicants: jobDetails?.pendingApplicants?.length || 0,
    //   percentage: ((jobDetails?.pendingApplicants?.length || 0) / (totalApplicantsForJob || 1)) * 100,
    // },
    ...dynamicStages,
    {
      stage: t(`Dashboard.Selected`),
      applicants: jobDetails?.selectedApplicants?.length || 0,
      percentage: Math.round(
        ((jobDetails?.selectedApplicants?.length || 0) /
          (totalApplicantsForJob || 1)) *
          100
      ),
    },
    {
      stage: t(`Dashboard.Onboarded`),
      applicants: jobDetails?.onboardedApplicants?.length || 0,
      percentage: Math.round(
        ((jobDetails?.onboardedApplicants?.length || 0) /
          (totalApplicantsForJob || 1)) *
          100
      ),
    },
  ];

  return (
    <div className="vacancy-tabel pt-0">
      <div className="container-fluid">
        <div className="funnel-charts-card">
          <div className="row">
            <div className="col-lg-12">
              <div className="eligible-content">
                <h3 className="d-flex align-items-center gap-2 heading-one">
                  {t(`Dashboard.Applicant Tracking Funnel`)}
                </h3>
                <h6 className="d-flex gap-3 tracking-fn">
                  <div className="tracking-fn">
                    <select
                      value={selectedJobTitle}
                      onChange={handleJobTitleChange}
                      className="job-dropdown form-select mb-0"
                      title={
                        jobTitles?.find(elem => elem.id == selectedJobTitle)
                          ?.title || t("Dashboard.Select job title")
                      }
                    >
                      <option
                        value=""
                        title={t("Dashboard.Select a job title")}
                      >
                        {t("Dashboard.Select job title")}
                      </option>
                      {jobTitles.map(job => (
                        <option key={job.id} value={job.id} title={job.title}>
                          {job.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  {selectedJobTitle ? (
                    <Link
                      to={`/job-posting/${selectedJobTitle}`}
                      className="gap-2 d-flex align-items-center view_link"
                    >
                      {t(`Dashboard.View All`)}{" "}
                      <img src={arrow1} alt="arrow 1" />
                    </Link>
                  ) : (
                    <Link
                      to="/pending-list"
                      className="gap-2 d-flex align-items-center view_link"
                    >
                      {t(`Dashboard.View All`)}{" "}
                      <img src={arrow1} alt="arrow 2" />
                    </Link>
                  )}
                </h6>
              </div>
            </div>
            <div className="col-lg-12">
              <FunnelSeries
                data={selectedJobTitle ? jobSpecificData : myData}
                t={t}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FunnelChart;
